import { FC } from 'react';
import { Box, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

const useStyles = makeStyles<Theme, { withBorder: boolean }>((theme) => ({
    root: {
        border: (props) => (props.withBorder ? `1px solid ${theme.palette.divider}` : 'none'),
    },
    paperBackgroundColor: {
        backgroundColor: theme.palette.background.paper,
    },
}));

interface IProps {
    index: number;
    value: number;
    whiteBg?: boolean;
    withBorder?: boolean;
    condensed?: boolean;
    /**
     * When false, omits role="tabpanel" and aria-labelledby so the panel isn't
     * advertised as a tabpanel referencing a Tab that wasn't rendered. Use this
     * when the caller renders panels without a paired set of <Tab> buttons.
     */
    asTabPanel?: boolean;
}

export const TabPanel: FC<IProps> = ({
    index,
    value,
    children,
    whiteBg = false,
    withBorder = true,
    condensed,
    asTabPanel = true,
}) => {
    const classes = useStyles({ withBorder });

    return (
        <div
            role={asTabPanel ? 'tabpanel' : undefined}
            hidden={value !== index}
            id={asTabPanel ? `tabpanel-${index}` : undefined}
            aria-labelledby={asTabPanel ? `tab-${index}` : undefined}
            className={clsx(classes.root, whiteBg ? classes.paperBackgroundColor : null)}
        >
            {value === index && <Box p={condensed ? 0 : 3}>{children}</Box>}
        </div>
    );
};
